export class ScheduleRowEntity {

    public static freeSlotTeamName: string = '';
    public static fromDto(dto: any): ScheduleRowEntity {
        if (!dto) {
            return new ScheduleRowEntity();
        }
        const entity = new ScheduleRowEntity();

        entity.id = dto.id;
        entity.homeTeam = dto.homeTeam;
        entity.opponentTeam = dto.opponentTeam;
        entity.fieldId = dto.fieldId;
        entity.interval = dto.interval;
        entity.concurrency = dto.concurrency;
        entity.scheduleId = dto.scheduleId;
        entity.groupId = dto.groupId;
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): ScheduleRowEntity[] {
        const entities: ScheduleRowEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = ScheduleRowEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public static toDtoArray(entityArray: ScheduleRowEntity[]): any[] {
        const dtos = [];
        if (entityArray == null) {
            return [];
        }
        for (const entity of entityArray) {
            dtos.push(entity.toDto());
        }
        return dtos;
    }

    public id: string = null;
    public scheduleId: string = null;
    public homeTeam: string = null;
    public opponentTeam: string = null;
    public fieldId: number = null;
    public interval: number = null;
    public concurrency: string = null;
    // The group this game belongs to. Lets multi-group penalty calculation disambiguate
    // teams that share a name across groups.
    public groupId: string = null;

    public get isEmpty(): boolean {
        return this.homeTeam === ScheduleRowEntity.freeSlotTeamName && this.opponentTeam === ScheduleRowEntity.freeSlotTeamName;
    }
    public toDto(): any {
        return {
            homeTeam: this.homeTeam,
            opponentTeam: this.opponentTeam,
            fieldId: this.fieldId,
            interval: this.interval,
            concurrency: this.concurrency,
            groupId: this.groupId
        };
    }

    public clone(): ScheduleRowEntity {
        return ScheduleRowEntity.fromDto(this.toDto());
    }
}
